import classNames from 'classnames';
import Image from 'next/image';
import Link from 'next/link';

import { SubCategory } from '@/entities/category';
import { IMAGE_QUALITY } from '@/shared/config';

import styles from './cardSmall.module.scss';

interface CardSmallProps {
  item: SubCategory;
  category: string;
  className?: string;
  sizes?: string;
}

export const CardSmall = (props: CardSmallProps) => {
  const {
    item,
    category,
    className,
    sizes = '(max-width: 1024px) 50vw, 33vw',
  } = props;

  if (!category) {
    return null;
  }

  return (
    <Link
      className={classNames(styles.card, className)}
      href={`/${category}/${item.slug}`}
    >
      <article className={styles.card__wrapper}>
        <div className={styles.card__image_block}>
          <Image
            alt={item.name}
            className={styles.card__image}
            height={1200}
            quality={IMAGE_QUALITY}
            sizes={sizes}
            src={item.image}
            width={1200}
          />
        </div>
        <div className={styles.card__content}>
          <p className={styles.card__title}>{item.name}</p>
          <p className={styles.card__count}>{item.products_count}</p>
        </div>
      </article>
    </Link>
  );
};
